import { JwtTokenFullData } from 'multirpc-sdk';
import { useEffect } from 'react';

import { usePersonalAccountState } from 'modules/personalAccount/hooks/usePersonalAccountState';

import { autorizeWorker } from '../utils/autorizeWorker';
import { useAccount } from './useAccount';
import { useAccountSetters } from './useAccountSetters';

export interface IUseInitWorkerProps {
  accountJWT: JwtTokenFullData;
}

export const useInitWorker = ({ accountJWT }: IUseInitWorkerProps) => {
  const { workerTokenData } = accountJWT;

  const {
    isFinance,
    isPersonalAccount,
    userEndpointToken: savedUserEndpointToken,
    workerToken: savedWorkerToken,
  } = useAccount();

  const {
    userEndpointToken: personalUserEndpointToken,
    workerToken: personalWorkerToken,
  } = usePersonalAccountState();

  const [userEndpointToken, workerToken] = isPersonalAccount
    ? [personalUserEndpointToken, personalWorkerToken]
    : [workerTokenData?.userEndpointToken, workerTokenData?.signedToken];

  const { setIsWorkerAuthorized, setUserEndpointToken, setWorkerToken } =
    useAccountSetters();

  useEffect(() => {
    if (savedUserEndpointToken && savedWorkerToken) {
      autorizeWorker({ workerToken: savedWorkerToken });

      setIsWorkerAuthorized(true);
    }
  }, [savedUserEndpointToken, savedWorkerToken, setIsWorkerAuthorized]);

  useEffect(() => {
    if (userEndpointToken && workerToken) {
      autorizeWorker({ workerToken });

      setIsWorkerAuthorized(true);
      setWorkerToken(workerToken);
      setUserEndpointToken(userEndpointToken);
    }
  }, [
    setIsWorkerAuthorized,
    setUserEndpointToken,
    setWorkerToken,
    userEndpointToken,
    workerToken,
  ]);

  useEffect(() => {
    if (isFinance) {
      setIsWorkerAuthorized(true);
    }
  }, [isFinance, setIsWorkerAuthorized]);
};
